import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DeleteUserDialogProps {
  opened: boolean;
  confirmationOpened: boolean;
  handleClose: () => void;
  validation: { reason: boolean };
  reason: string | null;
  deleteReasons?: string[];
  handleSetReason: (reason: string) => void;
  comment: string;
  handleComment: (event) => void;
  handleContinue: () => void;
}

export const DeleteUserDialog = ({
  opened,
  confirmationOpened,
  handleClose,
  validation,
  reason,
  deleteReasons,
  handleSetReason,
  comment,
  handleComment,
  handleContinue,
}: DeleteUserDialogProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog className="delete-user-feedback-dialog" open={opened && !confirmationOpened} onClose={handleClose}>
      <DialogTitle>{t('pages.settings.profile.delete.delete-title')}</DialogTitle>
      <DialogContent className="delete-user-feedback-dialog__content">
        <div className="delete-user-feedback-dialog__content-wrapper mobile-full-width">
          {/* DELETE REASONS */}
          <FormControl error={!validation.reason}>
            <FormLabel component="legend">{t('pages.settings.profile.delete.delete-reason')}:</FormLabel>
            <RadioGroup value={reason}>
              {deleteReasons?.map((radioReason) => (
                <FormControlLabel
                  key={radioReason}
                  className="delete-user-feedback-dialog__radio-control"
                  control={<Radio color="primary" size="small" />}
                  value={radioReason}
                  label={radioReason}
                  onChange={() => handleSetReason(radioReason)}
                />
              ))}
            </RadioGroup>
            {!validation.reason && <FormHelperText>{t('pages.settings.profile.delete.reason-error')}</FormHelperText>}
          </FormControl>

          {/* Feedback */}
          <TextField
            id="reason-comment"
            className="reason-comment"
            variant="standard"
            value={comment}
            onChange={handleComment}
            margin="normal"
            multiline={true}
            InputLabelProps={{
              shrink: true,
            }}
            label={`${t('pages.settings.profile.delete.send-feedback')}:`}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleContinue} color="primary">
          {t('common.continue')}
        </Button>
        <Button variant="outlined" onClick={handleClose} color="primary">
          {t('pages.settings.profile.delete.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
